import ActionTypes from 'store/actionTypes/mentor/menteeLists';
import GetOrderValue from 'types/GetOrderValue';

export type List = 'history';

type SetPage = (
  list: List,
  page: number,
) => { type: ActionTypes; value: number };
export const setPage: SetPage = (list, page) => {
  switch (list) {
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_PAGE,
        value: page,
      };
    default:
      return {
        type: ActionTypes.HISTORY_SET_PAGE,
        value: 0,
      };
  }
};

type SetSearch = (
  list: List,
  search: string,
) => { type: ActionTypes; value: string };
export const setSearch: SetSearch = (list, search) => {
  switch (list) {
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_SEARCH,
        value: search,
      };
    default:
      return {
        type: ActionTypes.HISTORY_SET_SEARCH,
        value: '',
      };
  }
};

type SetOrder = <OrderValue extends GetOrderValue<string>>(
  list: List,
  order: OrderValue,
) => { type: ActionTypes; value: OrderValue };
export const setOrder: SetOrder = (list, order) => {
  switch (list) {
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_ORDER,
        value: order,
      };
    default:
      return {
        type: ActionTypes.HISTORY_SET_ORDER,
        value: order,
      };
  }
};
